import React from "react";
import "../../../styles/styleComponents/SearchBar/SearchResults/searchResults.css";
import SearchResultsContainer from "../SearchResultsContainer/SearchResultsContainer";

const SearchResults = () => {
  return (
    <div className="search-result-container">
      <SearchResultsContainer />
    </div>
  );
};

export default SearchResults;
